import { useEffect } from "react";
import styled from "styled-components";
import theme from "../../styles/theme";
import SeasonsTable from "../../components/Drivers/CareerTable";
import { useNewsContext } from "../../contexts/news";
import { PostItem } from "../../components/News/NewsItem";
import TransparentButton from "../../components/Common/Buttons";
// Fix the import - make sure the path is correct
import RecentEvents from "./RecentEvents";

const Title = styled.div`
  font-family: "Montserrat", sans-serif;
  font-size: 16px;
  font-weight: bold;
  padding-left: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const NewsContainer = styled.div`
  margin-top: 24px;
  background: #2a2a2ac4;
  border: 2px solid #393b40;
  padding: 16px;
  border-radius: 4px;
  width: fit-content;
  @media (max-width: ${theme.breakpointsCustom.md}px) {
    width: 100%;
  }
`;

const FilteredPostContainer = styled.div`
  display: flex;
  gap: 16px;

  @media (max-width: 1200px) {
    flex-wrap: wrap;
  }

  @media (max-width: ${theme.breakpointsCustom.md}px) {
    justify-content: center;
  }
`;

const PostContainer = styled.div`
  max-width: 300px;

  @media (max-width: ${theme.breakpointsCustom.sm}px) {
    max-width: none;
  }
`;

const DriverOverview = ({ driverDetails, driverFullName }) => {
  const { filteredPosts, loadPosts, tags } = useNewsContext();

  useEffect(() => {
    if (driverFullName) {
      loadPosts({
        filter: { tags: { name: driverFullName } },
      });
    }
  }, [driverFullName, loadPosts]);

  const carrier = driverDetails.carrier || [];
  const team = driverDetails.team || [];

  return (
    <>
      <RecentEvents />

      <SeasonsTable seasons={carrier} team={team} />

      {filteredPosts.length > 0 && (
        <NewsContainer>
          <Title style={{ padding: "0px", marginBottom: "16px" }}>
            Новини
            {filteredPosts.length > 3 && (
              <TransparentButton
                style={{ fontSize: "12px" }}
                onClick={() => {
                  const fullNameTag = `${driverDetails.firstName} ${driverDetails.lastName}`;
                  const tag = tags.find((tag) => tag.name === fullNameTag);
                  if (tag) {
                    window.location.href = `/news?tags=${tag.id}`;
                  }
                }}
              >
                Показати все
              </TransparentButton>
            )}
          </Title>

          <FilteredPostContainer>
            {filteredPosts.slice(0, 3).map((post) => (
              <PostContainer key={post.id}>
                <PostItem {...post} />
              </PostContainer>
            ))}
          </FilteredPostContainer>
        </NewsContainer>
      )}
    </>
  );
};

export default DriverOverview;
